function Facebook() {
  return (
    <svg
      className="smartBanner__facebook-icon"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.358H7.332v3.209h2.747v8.196h3.318z" />
    </svg>
  );
}

export default Facebook;
